export default "__VITE_ASSET__BAG7EQug__"